module.exports = __webpack_public_path__ + "img/crustaces-en-ligne-boutrais-small.4d1c64db.png";